module.exports = __webpack_public_path__ + "img/qrcode.640b20bc.jpg";